import { RaxBFF } from './booker.planner.bff.api';
import { bookerJsonParseReviver } from './bookerJsonParseReviver';

export class BookerPlannerBffApiClient extends RaxBFF.Client {
    protected override jsonParseReviver = (key: string, value: unknown): unknown => bookerJsonParseReviver(key, value);
}
